module.exports = __webpack_public_path__ + "img/La Roda.8135ddf5.jpg";